import "sweetalert";

// NOTE: The form element may not actually be a Form. This is because sometimes the label creator may be used inside
// a form, preventing the creator from nesting its own form element. Thus, the creator form may actually be a DIV.
(function ($) {
  window.LabelCreator = function (container) {
    container = jQuery(container);
    var context = this;
    var labelCreatedEvent = "labelCreated";
    var submitButton = container.find(".submit-button");
    var form = submitButton.closest("[action]");
    var parentForm = jQuery(submitButton).closest("form");

    // BEHAVIOUR

    parentForm.on("submit", submitIfFromContainer);
    submitButton.on("click", submitAndCancelEvent);

    // INITIALIZE

    container.addClass("xhr-enabled");

    // EVENT HANDLERS

    function submitIfFromContainer(event) {
      if (jQuery.contains(container[0], jQuery(":focus")[0])) {
        submitAndCancelEvent(event);
      }
    }

    function submitAndCancelEvent(event) {
      if (event.isDefaultPrevented()) {
        return;
      }
      submit();
      event.preventDefault();
    }

    // HELPER FUNCTIONS

    function submit() {
      jQuery
        .post(form.attr("action"), form.find(":input").serialize(), null, "json")
        .done(triggerLabelAdded, resetForm)
        .fail(displayError);
    }

    function triggerLabelAdded(response) {
      container.trigger(labelCreatedEvent, [response]);
      jQuery(context).trigger(labelCreatedEvent, [response]);
    }

    function resetForm() {
      form.find("input:text").val("");
    }

    function displayError(data) {
      var errors = [];
      jQuery.each(data.responseJSON.errors, function (name, error) {
        errors.push(name + " " + error);
      });
      swal("Error creating label", errors.join(". "), "error");
    }

    function preventDefaultAfter(fn) {
      return function (event) {
        fn.apply(this, arguments);
        event.preventDefault();
      };
    }
  };
})(jQuery);
